module.exports = __webpack_public_path__ + "img/utenti_aziende_smartform.f9dcb6dd.png";